"use strict";

import classNames from "classnames";
import React from "react";
export var RainbowBar = function RainbowBar(_ref) {
  var _ref$isTopRounded = _ref.isTopRounded,
    isTopRounded = _ref$isTopRounded === void 0 ? true : _ref$isTopRounded,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size;
  return /* @__PURE__ */React.createElement("div", {
    className: classNames("rainbow-bar", {
      "rainbow-bar--rounded-top": isTopRounded,
      "rainbow-bar--small": size === "small"
    })
  });
};
export default RainbowBar;